const MenuItems = [
  {
    title: 'Join Today',
    url: '/payments',
  },
  {
    title: 'Members',
    url: '/directory',
  },
  {
    title: 'Deals',
    url: '/deals',
  },
  {
    title: 'Mentors',
    url: '/mentors',
  },
  {
    title: "What's a Mastermind?",
    url: '/resources',
  },
  {
    title: 'Case Studies',
    url: '/stories',
  },
  {
    title: 'The Pre-100 Club',
    url: '/pre100',
  },
  {
    title: 'Join the Team',
    url: '/joinTheTeam',
  },
  {
    title: 'About Us',
    url: '/about',
  },
  {
    title: 'Privacy',
    url: '/privacy',
  },
  {
    title: 'Terms and Conditions',
    url: '/tnc',
  },
];

export default MenuItems;
